/**
 * Utilidades de fecha para hora Chile (UTC-4/UTC-3 con horario de verano).
 * new Date().toISOString() siempre usa UTC, lo que al final del día
 * en Chile muestra la fecha del día siguiente.
 */

/** Retorna la fecha actual en formato YYYY-MM-DD según hora Chile continental */
export const hoyChile = () => {
    const ahora = new Date();
    const offset = -4; // Chile UTC-4 (horario estándar)
    const local = new Date(ahora.getTime() + (offset * 60 * 60 * 1000));
    return local.toISOString().split('T')[0];
};

/**
 * Retorna la fecha (YYYY-MM-DD) de la JORNADA en curso para un turno.
 *
 * Para un turno normal (ej 08:00-16:00) la jornada es simplemente el día de
 * hoy. Para uno que cruza medianoche (ej 18:00-02:00) la jornada del turno
 * que arrancó anoche sigue vigente hasta su hora de cierre: a la 01:00 del
 * martes todavía estamos en la jornada del lunes, así que devuelve el lunes.
 *
 * Sirve para que el cajero que cierra caja a la 01:00 abra el reporte y vea
 * su turno, en vez de una pantalla vacía por estar parado en el día nuevo.
 * El backend agrupa con este mismo criterio (ver _filtro_periodo en
 * api_vtgx_reportes.py).
 *
 * Si falta cualquiera de las dos horas, cae en hoyChile().
 */
export const jornadaChile = (horaInicio, horaFin) => {
    const local = new Date(new Date().getTime() + (-4 * 60 * 60 * 1000));
    const hoy = local.toISOString().split('T')[0];

    if (!horaInicio || !horaFin) return hoy;

    const [hi, mi] = String(horaInicio).split(':').map(Number);
    const [hf, mf] = String(horaFin).split(':').map(Number);
    if ([hi, mi, hf, mf].some((n) => Number.isNaN(n))) return hoy;

    const minInicio = hi * 60 + mi;
    const minFin = hf * 60 + mf;

    // No cruza medianoche: la jornada es el día calendario, sin más.
    if (minFin > minInicio) return hoy;

    // Cruza medianoche: si todavía no llegamos a la hora de cierre, seguimos
    // dentro de la jornada que empezó ayer.
    const minAhora = local.getUTCHours() * 60 + local.getUTCMinutes();
    if (minAhora < minFin) {
        const ayer = new Date(local.getTime() - 24 * 60 * 60 * 1000);
        return ayer.toISOString().split('T')[0];
    }
    return hoy;
};

/** Retorna el primer día del mes actual en formato YYYY-MM-DD */
export const primerDiaMesChile = () => {
    const ahora = new Date();
    const offset = -4;
    const local = new Date(ahora.getTime() + (offset * 60 * 60 * 1000));
    return `${local.getFullYear()}-${String(local.getMonth() + 1).padStart(2, '0')}-01`;
};